import { useAppQuery } from "~/hooks/useAppQuery"
import { feedEventsQueryKey } from "../query-keys"
import { getMyEvents } from "../server/feed.functions"

export function useEvents() {
  return useAppQuery({
    queryKey: feedEventsQueryKey(),
    queryFn: () => getMyEvents(),
    errorMessage: "Не удалось загрузить события",
  })
}
